import React from 'react';
import { FieldErrors } from './FieldErrors';
export const RecordSelectInput = (props) => {
    const onChange = (event) => {
        if (event.currentTarget.value) {
            props.onChange(parseInt(event.currentTarget.value, 10));
        }
        else {
            props.onChange(null);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "input__select" },
            React.createElement("label", { htmlFor: props.id },
                props.label,
                props.required ? ' *' : ''),
            React.createElement("select", { id: props.id, value: props.value || '', name: props.name, onChange: onChange },
                React.createElement("option", { value: "" }),
                props.options.map((o) => {
                    return (React.createElement("option", { key: o.id, value: o.id }, o.name));
                }))),
        React.createElement(FieldErrors, { errors: props.errors, name: props.name || props.id })));
};
